import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {TitleComponent} from "../title/title.component";

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {

  constructor(
    private title : TitleComponent,
    public router: Router
  ) { }

  ngOnInit() {
  }


  goToLink(){
    this.router.navigate(['/login']);

  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/terms-conditions/terms-conditions.component.ts